import { render } from "./DeleteChatConfirmModal.vue?vue&type=template&id=d961bc94&scoped=true"
import script from "./DeleteChatConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeleteChatConfirmModal.vue?vue&type=script&lang=js"

import "./DeleteChatConfirmModal.vue?vue&type=style&index=0&id=d961bc94&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d961bc94"]])

export default __exports__